'use client';

import classnames from 'classnames';
import styles from './ToggleRow.module.scss';

interface ToggleRowProps {
  readonly id: string;
  readonly label: string;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  /** Extra class for the row, e.g. to size its text and checkbox. */
  readonly className?: string;
}

/** A labeled checkbox row: the label on the left, the checkbox on the right. */
export function ToggleRow({ id, label, checked, onChange, className }: ToggleRowProps): JSX.Element {
  return (
    <label htmlFor={id} className={classnames(styles.toggleRow, className)}>
      <span>{label}</span>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
    </label>
  );
}
